export const MODELS = {
    ORDER: "\\danielstandard\\store\\models\\Order\\Order",
    ACCOUNT: "\\danielstandard\\store\\models\\Account\\Account",
    PAYMENT: "\\danielstandard\\store\\models\\Payment\\Payment",
    CLIENT: "\\danielstandard\\store\\models\\Client\\Client",
    RETURN: "\\danielstandard\\store\\models\\ReturnOrder\\ReturnOrder",
    INVOICE: "\\danielstandard\\store\\models\\Invoice\\Invoice",
    DOCUMENT: "\\danielstandard\\store\\models\\Document\\Document",
};